module.exports = "/_next/static/images/section-for-renewable-energy-mob-c7d7c330804762e8bb2ce5d82d5e4c22.png.webp";